(function() {
    'use strict';

    angular.module('product').controller('DiscountsUpdateModalController', DiscountsUpdateModalController);

    DiscountsUpdateModalController.$inject = ['$uibModalInstance', 'dataObj', 'discountDataSrvc', 'notificationSrvc', 'discountMessagesConst'];

    function DiscountsUpdateModalController($uibModalInstance, dataObj, discountDataSrvc, notificationSrvc, discountMessagesConst) {
        var self = this;

        self.serverErrors = [];
        self.loading = false;
        self.saving = false;

        if (dataObj.hasOwnProperty("children")) {
            self.discountId = null;
            self.discount = dataObj;
        } else {
            self.discountId = dataObj.discountId;
            self.discount = null;
        }
        // The modal gets the discounts ready only from the price assistant file.
        self.fromAssistant = self.discountId === null;

        self.formSubmit = formSubmit;
        self.modalClose = modalClose;
        self.cleanErrors = cleanErrors;
        self.selectAllRows = selectAllRows;
        self.changeSelectedFieldValue = changeSelectedFieldValue;
        self.changeSelectedFieldValueByDiscountField = changeSelectedFieldValueByDiscountField;

        self.discountFieldErrors = {
            'value': []
        };
        self.discountField = {
            'value': 0
        }

        activate();

        function activate() {
            getDiscount(self.discountId);
        }

        function getDiscount(discountId) {
            if (discountId !== null) {
                self.loading = true;
                return discountDataSrvc.get({pk: discountId}).$promise.then(
                    function (response) {
                        self.discount = response;
                        self.loading = false;
                    },
                    function (response) {
                    }
                )
            }
        }

        function formSubmit() {
            // One save at a time - the button is locked until the response.
            if (self.saving) {
                return;
            }
            self.saving = true;
            // Values from the price assistant are saved under all categories
            // of the product, with the cascade in every branch.
            var params = self.fromAssistant ? {all_categories: 'true'} : {};
            discountDataSrvc.updateDiscountsForQuantity(params, self.discount.children)
                .$promise.then(
                    function (response) {
                        $uibModalInstance.close();
                        notificationSrvc.notification("success", discountMessagesConst.updateManySuccess);
                    },
                    function (response) {
                        self.saving = false;
                        self.serverErrors = response.data;
                        notificationSrvc.notification("error", discountMessagesConst.updateManyError);
                    }
            )
        }

        function modalClose() {
            self.discountId = null;
            $uibModalInstance.dismiss('cancel');
        }

        function cleanErrors(errorField, key) {
            if (errorField !== undefined) {
                errorField[key] = [];
            }
        }

        function selectAllRows(evt) {
            var rows = angular.element(document.querySelectorAll(".select-row"));
            for (var i=0; i<rows.length; i++) {
                rows[i].checked = evt.currentTarget.checked;
            }
        }

        function changeSelectedFieldValue(evt, value){
            var selectedRows = angular.element(document.querySelectorAll(".select-row:checked"));
            for (var i=0; i < selectedRows.length; i++) {
                var selectedIndex = selectedRows[i].dataset.index;
                var selectedDiscount = self.discount.children[selectedIndex];
                if (!isNaN(selectedDiscount.value) && !isNaN(value)){
                    selectedDiscount.value = (Number(selectedDiscount.value) + Number(value)).toFixed(2);
                }
            }
        }

        function validateDiscountFieldValue(value){
            var isValid = true;
            if (isNaN(value)){
                isValid = false;
                self.discountFieldErrors.value.push("Wymagana poprawna liczba.")
            }
            return isValid
        }

        function changeSelectedFieldValueByDiscountField(evt){
            if(validateDiscountFieldValue(self.discountField.value)){
                changeSelectedFieldValue(evt, self.discountField.value)
            }
        }
    }
})();
